import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { Activity, ChevronRight } from "lucide-react";

const STEPS = ["breakout_step1", "breakout_step2", "breakout_step3", "breakout_step4", "breakout_step5", "breakout_step6", "breakout_step7"];

export default function BreakoutHub() {
  const { t } = useI18n();
  const navigate = useNavigate();
  usePageMeta(t("breakout"));

  return (
    <div className="mx-auto max-w-xl space-y-6" data-testid="breakout-hub">
      <div>
        <h1 className="font-display text-3xl text-foreground">{t("breakout")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("breakout_tab_sub")}</p>
      </div>

      <button
        onClick={() => navigate("/app/breakout/session")}
        data-testid="breakout-start-session"
        className="flex w-full flex-col gap-1.5 rounded-3xl bg-primary p-6 text-left text-primary-foreground transition-all hover:-translate-y-0.5 hover:shadow-lg"
      >
        <Activity className="h-7 w-7" />
        <span className="mt-1 font-display text-2xl">{t("breakout_start_session")}</span>
        <span className="text-sm opacity-90">{t("breakout_start_sub")}</span>
      </button>

      <div className="rounded-2xl border border-border bg-card p-5">
        <h2 className="mb-3 font-display text-lg text-foreground">{t("breakout_how_it_works")}</h2>
        <div className="space-y-1">
          {STEPS.map((k, i) => (
            <div key={k} className="flex items-start gap-3 py-1.5">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/15 text-xs font-semibold text-primary">{i + 1}</span>
              <p className="pt-0.5 text-sm text-foreground">{t(k)}</p>
            </div>
          ))}
        </div>
      </div>

      <button onClick={() => navigate("/app/breakout/session")} data-testid="breakout-start-session-bottom" className="flex w-full items-center justify-center gap-2 rounded-full border border-border py-3 text-sm font-medium text-foreground hover:bg-accent">
        {t("breakout_start_session")} <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
